<template>
	<Modal
		:modal-name="modalName"
		type="dialog"
		:theme="!$arenaConfig.isLightTheme ? 'dark' : 'light'"
		@opened="init"
	>
		<template #title>
			{{ $I18n.trans('commons.download_video') }}
		</template>
		<template #content>
			<p class="u-mb-6">
				{{ $I18n.trans('event.multiformat_editor.messages.video_created') }}
			</p>
			<InputCopy
				:label="$I18n.trans('event.multiformat_editor.labels.copy_link', {days: `${remainingDays} ${$I18n.trans_choice('commons.day', remainingDays)}`})"
				:value="cropVideoDownloadUrl"
				:no-wrap="true"
				:dark-theme="!$arenaConfig.isLightTheme"
			/>
		</template>
		<template #footer>
			<div class="l-button-group">
				<Button
					:text="$Helpers.ucfirst($I18n.trans('commons.close'))"
					modifier="secondary"
					:theme="!$arenaConfig.isLightTheme ? 'dark' : 'light'"
					@click="closeDownloadModal"
				/>
				<Button
					:text="$Helpers.ucfirst($I18n.trans('commons.download'))"
					:busy="!cropVideoDownloadUrl"
					:theme="!$arenaConfig.isLightTheme ? 'dark' : 'light'"
					@click="downloadCropVideo"
				/>
			</div>
		</template>
	</Modal>
</template>

<script>
import Modal from '@shared/components/Modal';
import Button from '@shared/components/Button';
import InputCopy from '@shared/components/Form/InputCopy';
import { getShortLinkForMoment } from '@shared/utils/getShortLink';
import moment from 'moment';

export default {
	name:       'ModalMomentDownload',
	components: { Modal, Button, InputCopy },
	props:      {
		modalName: {
			type:     String,
			required: true,
		},
	},
	data() {
		return {
			cropVideoDownloadUrl: '',
			remainingDays:        window.cropDefaultExpiryDays,
		};
	},
	methods: {
		async init(momentCrop) {
			if (momentCrop.expiresAt) {
				this.remainingDays = Math.ceil(moment(momentCrop.expiresAt).diff(moment(), 'days', true));
			}
			this.cropVideoDownloadUrl = await getShortLinkForMoment(momentCrop.id);
		},
		closeDownloadModal() {
			window.eventBus.$emit(`modalClose:${this.modalName}`);
		},
		downloadCropVideo() {
			window.open(this.cropVideoDownloadUrl, '_blank');
		},
	},
};
</script>

<style>

</style>
